import React from 'react';
import { createComponent } from '@lit/react';
import { SDSText } from '../sds-text/sds-text';

export const SDSTextWrapper = createComponent({
	tagName: 'sds-text',
	elementClass: SDSText,
	react: React,
	events: {},
});
